var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "108px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    strokeWidth: 1.9200000000000004
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    transform: "translate(-251.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(251.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    fillRule: "nonzero",
    height: 24,
    id: "\\u77E9\\u5F62",
    width: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16 L18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 1.9200000000000004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16 L6,16",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 1.9200000000000004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,16 L6,15.75 L6,14.5 L6,12 L6,8 C6,4.68629 8.6863,2 12,2 C15.3137,2 18,4.68629 18,8 L18,16 C18,19.3137 15.3137,22 12,22",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9200000000000004
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.37c31110368701c0fd3ae9386589abc3.svg";
export { ForwardRef as ReactComponent };